namespace GeniuzPOS.ReportMasterData {
    export interface Report_1313Row {
        Id?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        FullName?: string;
        FullName3?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1313Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1313';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            FullName = "FullName",
            FullName3 = "FullName3",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
